import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.welcomeUserRegistration.pageTitle',
    defaultMessage: 'Benvenuto',
    description: 'Title of the welcome user registration page',
  },
  pageSubtitle: {
    id: 'features.welcomeUserRegistration.pageSubtitle',
    defaultMessage: 'Prosegui con la registrazione',
    description: 'Subtitle of the welcome user registration page',
  },
  buttonWelcomeUserRegistration: {
    id: 'features.welcomeUserRegistration.buttonWelcomeUserRegistration',
    defaultMessage: 'Avanti',
    description: 'Label of the welcome user registration button',
  },
  backTo: {
    id: 'features.welcomeUserRegistration.backTo',
    defaultMessage: 'Torna alla login',
    description: 'Disclaimer "back to login"',
  },
  textWelcomeUserRegistration: {
    id: 'features.welcomeUserRegistration.textWelcomeUserRegistration',
    defaultMessage:
      'Gentile {name} {surname}, benvenuto/a in MyAzimut, il portale riservato ai nostri clienti. Trattandosi del tuo primo accesso, per ragioni di privacy e di sicurezza, ti chiediamo alcuni minuti per configurare correttamente il servizio, inserendo e confermando i dati richiesti a seguire.',
    description: 'Text of welcome page',
  },
});
